import * as React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

const rootEl = document.getElementById("root");

ReactDOM.render(<App />, rootEl);
